<template>
    <div class="mt-5">
        <v-data-table :headers="headers" :items="extDataList" :items-per-page="pagination.perPage"
      :page="pagination.currentPage" no-data-text="暂无属性" hide-default-footer
            class="paginated-table table-striped">
            <template v-slot:top>
                <v-row justify="space-between">
                    <v-col class="d-flex" cols="6" sm="2">
                        <v-select
                        v-model="pagination.perPage"
                        :items="pagination.perPageOptions"
                        label="每页显示"
                        ></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="6" sm="2">
                        <v-text-field
                        v-model="queryParams.name"
                        label="查找"
                        type="search"
                        class="mb-3"
                        clearable
                        style="width: 200px"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.variable_type="{ item }">{{ type_map[item.variable_type] }}</template>
            <template v-slot:item.option="{ item, index }">
                <v-btn icon color="green darken-1" small @click.native="editExtendedProperty(item)">
                    <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="red darken-1" small @click.native="delExtendedProperty(index)">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <div class="d-flex justify-space-between align-center mt-4">
            <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
            <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="pagination.total">
            </pagination>
            <v-btn color="success" small @click.stop="addExtendedProperty">新增</v-btn>
        </div>

        <v-dialog hide-overlay v-model="showExtDialog" max-width="600px">
            <v-form v-model="validForm" @submit.prevent="confirm">
                <v-card class="window-card">
                    <div class="d-flex align-end mb-3">
                        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
                            <v-icon color="white"> mdi-bookmark </v-icon>
                        </v-card>
                        <span class="h4 ml-1 mb-n1">拓展属性</span>
                    </div>
                    <v-card-text>
                        <v-text-field
                            v-model="form.name"
                            label="属性名称*"
                            :rules="
                            [
                                v => !!v || '属性名称不能为空'
                                , v => checkPropName(v) || '该属性名称已存在'
                                , v => checkNameRule(v) || '属性名称不合法，请使用数字、_、英文大小写字母命名，不能以数字开头且名称内容不能包含特殊字符'
                            ]"
                        ></v-text-field>
                        <v-select v-model="form.variable_type" :items="type_list" item-text="label" item-value="value"
                            label="属性类型*" :rules="[v => !!v || '属性类型不能为空']"></v-select>
                        <v-text-field v-model="form.default_value" label="默认值"
                            v-if="form.variable_type === 'string'"></v-text-field>
                        <v-text-field v-model="form.default_value" label="默认值"
                            v-if="form.variable_type === 'int' || form.variable_type === 'float'"></v-text-field>
                        <v-select v-model="form.default_value" :items="form.ranges" label="默认值*"
                            :rules="[v => !!v || '默认值不能为空']" v-if="form.variable_type === 'enum'"></v-select>
                        <div v-if="form.variable_type === 'bool'">
                            <label style="margin-right: 15px;">默认值</label>
                            <v-radio-group v-model="form.default_value">
                                <v-radio label="true" value="true"></v-radio>
                                <v-radio label="false" value="false"></v-radio>
                            </v-radio-group>
                        </div>
                        <div class="md-layout" v-show="form.variable_type === 'int'">
                            <label class="md-layout-item md-size-10 md-form-label" style="text-align: left"> 取值范围
                            </label>
                            <div class="md-layout-item md-size-45">
                                <v-text-field v-model="form.minIntValue" label="最小值"></v-text-field>
                            </div>
                            <div class="md-layout-item md-size-45" style="padding-right: 0px">
                                <v-text-field v-model="form.maxIntValue" label="最大值"></v-text-field>
                            </div>
                        </div>
                        <div class="md-layout" v-show="form.variable_type === 'float'">
                            <label class="md-layout-item md-size-10 md-form-label" style="text-align: left"> 取值范围
                            </label>
                            <div class="md-layout-item md-size-45">
                                <v-text-field v-model="form.minFloatValue" label="最小值"></v-text-field>
                            </div>
                            <div class="md-layout-item md-size-45" style="padding-right: 0px">
                                <v-text-field v-model="form.maxFloatValue" label="最大值"></v-text-field>
                            </div>
                        </div>
                        <!-- <v-text-field v-model="form.ranges" label="取值范围" hint="请输入取值并回车..."
                            v-show="form.variable_type === 'enum'"></v-text-field> -->
                        <v-combobox v-model="form.ranges" :items="claimDatas" hint="请输入取值并回车..." chips clearable multiple
                            label="取值范围" v-show="form.variable_type === 'enum'">
                            <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                                @click:close="remove(item)">
                                <strong>{{ item }}</strong>
                            </v-chip>
                        </v-combobox>
                        <!-- <v-text-field v-model="form.unit" label="单位"></v-text-field> -->
                        <v-text-field v-model="form.remark" label="备注"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" type="submit">确定</v-btn>
                        <v-btn color="gray" @click="(showExtDialog = false)">关闭</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>
<script>
import { Pagination } from "@/components";
import { mapState, mapGetters } from 'vuex'
import { type_list } from './PropertyTypeList'
import { checkNameRule } from "@/utils/util"

const type_map = type_list.reduce((pre, next) => {
    pre[next.value] = next.label
    return pre
}, {})

export default {
    name: 'ExtTab',
    components: { Pagination },
    computed: {
        ...mapState({
            typeForm: state => state.editorType.typeForm
        }),
        ...mapGetters(['propList']),
        extDataList() {
            return this.propList.filter(item => new RegExp(this.queryParams.name).test(item.name));
        },
        from() {
            return (this.pagination.currentPage - 1) * this.pagination.perPage;
        },
        to() {
            return this.pagination.currentPage * this.pagination.perPage;
        },
        total() {
            const total = this.extDataList ? this.extDataList.length : 0;
            this.pagination.total = total;
            return total;
        },
    },
    watch: {
        'form.variable_type'() {
            this.form.default_value = ''
        }
    },
    data() {
        return {
            headers: [
                { text: '属性名称', align: 'center', value: 'name' },
                { text: '属性类型', align: 'center', value: 'variable_type' },
                { text: '默认值', align: 'center', value: 'default_value' },
                // { text: '单位', align: 'center', value: 'unit' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            claimDatas: [], //自定义取值范围
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 15, 25],
                total: 0,
            },
            form: {},
            validForm: false,
            type_list,
            type_map,
            showExtDialog: false,
            queryParams: {
                name: ''
            }
        }
    },
    methods: {
        checkPropName(name) {
            if (this.form.id && name === this.form.name) {
                return true
            }
            return (this.propList.findIndex(item => item.name === name) === -1)
        },
        checkNameRule,
        addExtendedProperty() {
            this.showExtDialog = true
            this.initForm()
        },
        editExtendedProperty(item) {
            this.form = Object.assign({}, item)
            console.log('this.form :>> ', this.form);
            this.showExtDialog = true
        },
        delExtendedProperty(index) {
            this.$store.dispatch('editorType/removeProp', index);
        },
        confirm() {
            if (!this.validForm) {
                this.$store.dispatch('global/showWarningMsg', '校验未通过，请检查表单填写是否正确')
                return;
            }
            this.$store.dispatch('editorType/setExtendedProperties', this.form)
            this.showExtDialog = false
        },
        initForm() {
            this.form = {
                type: 'add',
                name: '',
                remark: '',
                variable_type: '',
                default_value: '',
                unit: '',
                ranges: []
            }
        }
    }
}
</script>